import { X, Car, Trash, SquarePen } from "lucide-react"
import LineTicket from "./LineTicket";
import styles from "./ModalDataCar.module.css"
import { useState } from "react";
import SectionRegister from "../SectionRegister";

function ModalDataCar({ setIsOpen, thisCar, setIsOpenEdit, setIsOpenDelete }) {
    const [sectionSelected, setSectionSelected] = useState("Registro");

    const tickets = thisCar.tickets;

    const dataRegister = [
        {
            label: "ID",
            value: thisCar.id,
        },
        {
            label: "PLACA",
            value: thisCar.placa,
        },
        {
            label: "MARCA",
            value: thisCar.marca,
        },
        {
            label: "MODELO",
            value: thisCar.model,
        },

        {
            label: "COR",
            value: thisCar.color,
        },

        {
            label: "TÉCNICO RES.",
            value: thisCar.tecnico?.name
        }
    ]


    return (
        <div className={styles.container}>
            <div className={styles.form}>
                <div className={styles.containerHeader}>
                    <div className={styles.extra}>
                        <div className={styles.icon}>
                            <Car color="#fff" size={28} />
                        </div>
                        <div className={styles.infoHeader}>
                            <h3>{`${thisCar.marca} ${thisCar.model}`}</h3>
                            <div className={styles.infoCar}>
                                <p>{thisCar.placa}</p>
                                <p>{`ID: ${thisCar.id}`}</p>
                            </div>
                        </div>
                    </div>
                    <div className={styles.x}>
                        <X onClick={() => setIsOpen(false)} color="#fff" />
                    </div>
                </div>
                <div className={styles.options}>
                    <button
                        className={sectionSelected == "Registro" ? `${styles.btnOptSelect} ${styles.active}` : styles.btnOpt}
                        onClick={() => setSectionSelected("Registro")}
                    >
                        Registro
                    </button>
                    <button
                        className={sectionSelected == "Tickets" ? `${styles.btnOptSelect} ${styles.active}` : styles.btnOpt}
                        onClick={() => setSectionSelected("Tickets")}
                    >
                        Tickets
                    </button>
                    <button
                        className={sectionSelected == "Alertas" ? `${styles.btnOptSelect} ${styles.active}` : styles.btnOpt}
                        onClick={() => setSectionSelected("Alertas")}
                    >
                        Alertas
                    </button>
                    <button
                        className={sectionSelected == "Km" ? `${styles.btnOptSelect} ${styles.active}` : styles.btnOpt}
                        onClick={() => setSectionSelected("Km")}
                    >
                        Km
                    </button>
                </div>
                <div className={styles.content}>
                    {sectionSelected == "Registro" && (
                        <SectionRegister
                            thisEntity={dataRegister}
                        />
                    )}
                    {sectionSelected == "Tickets" && (
                        <section className={styles.tickets} style={{
                            gridTemplateRows: `repeat(${tickets.length}, 1fr)`
                        }}>
                            <div className={styles.column}>
                                <div className={styles.line}>
                                    <span>ID</span>
                                </div>
                                <div className={styles.line}>
                                    <span>Status</span>
                                </div>
                                <div className={styles.line}>
                                    <span>ID Checklist</span>
                                </div>
                                <div className={styles.line}>
                                    <span>Data Abertura</span>
                                </div>
                            </div>
                            {tickets.length > 0 ? tickets.map((ticket) => {
                                return <LineTicket thisTicket={ticket} />
                            }) : " "}
                        </section>
                    )}
                </div>
                <div className={styles.buttonOperations}>
                    <button
                        className={styles.edit}
                        onClick={() => {
                            setIsOpen(false)
                            setIsOpenEdit(true)
                        }}
                    >
                        <SquarePen size={14} color="#1d121b" />
                        Editar
                    </button>
                    <button
                        className={styles.delete}
                        onClick={() => {
                            setIsOpen(false);
                            setIsOpenDelete(true)
                        }}
                    >
                        <Trash size={14} color="#fff" />
                        Excluir
                    </button>
                </div>
            </div>
        </div>
    )
}

export default ModalDataCar;